var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUtilityLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#fff",
    stroke: "#E5E8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M26.1914 37.8623C26.1914 35.4944 27.457 33.2917 30.5554 32.4625C33.6539 31.6333 63.2858 25 63.2858 25C65.696 25 67.6498 26.9195 67.6498 29.2874V45.3653V61.4431C67.6498 63.811 65.696 65.7305 63.2858 65.7305L30.5554 72.1616C28.1453 74.3054 26.1914 72.3858 26.1914 70.0179V37.8623Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M26 38.3667C26 35.6053 28.2386 33.3667 31 33.3667H67C69.7614 33.3667 72 35.6053 72 38.3667V69.3667C72 72.1281 69.7614 74.3667 67 74.3667H31C28.2386 74.3667 26 72.1281 26 69.3667V38.3667Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M49 49.3667C49 46.6053 51.2386 44.3667 54 44.3667H70C72.7614 44.3667 75 46.6053 75 49.3667V57.3667C75 60.1281 72.7614 62.3667 70 62.3667H54C51.2386 62.3667 49 60.1281 49 57.3667V49.3667Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M61.0165 53.6834C61.0165 55.5151 59.5316 57 57.6999 57C55.8681 57 54.3832 55.5151 54.3832 53.6834C54.3832 51.8516 55.8681 50.3667 57.6999 50.3667C59.5316 50.3667 61.0165 51.8516 61.0165 53.6834Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilityLight);
export default __webpack_public_path__ + "static/media/utility-light.a802446312937ebda932d2a56b799234.svg";
export { ForwardRef as ReactComponent };